import moment from 'moment'
import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Pager from '../../components/pager'
import * as Sortable from '../../components/sortable'
import * as Constants from './constants'
import * as Types from './types'

export interface View extends Sortable.SortableViewState, IsActive.FilterableState {
}
interface SearchAction extends Redux.Action {
  term: string,
}

const emptySearchState: Types.SearchState = {
  term: '',
}
export const searchReducer = (state: Types.SearchState = emptySearchState, action: SearchAction) => {
  switch (action.type) {
    case Constants.UPDATE_BLACKLIST_SEARCH_STRING:
      return {
        ...state,
        term: action.term,
      }
    default:
      return state
  }
}
const normalizeTypes: Sortable.TypeNormalizer<Types.ExcludedUrl> = (
  payload: Sortable.SortableData<Types.ExcludedUrl>): Sortable.SortableData<Types.ExcludedUrl> => {
  return payload.map((lp: Types.ExcludedUrl) => ({
    ...lp,
    created_datetime: moment(lp.created),
  }))
}

const reducerEvent: Sortable.ReducerEvent<Types.ExcludedUrl> = {
  defaultSort: {field: 'id', dir: 'desc'},
  normalizer: normalizeTypes,
  requestEvent: Constants.FETCH_EXCLUDED_LIST,
}

const modalReducerEvent: Modal.ReducerEvent<Types.ModalData> = {
  initializeState: () => Constants.emptyModalState,
  requestEvent: Constants.ADD_EXCLUDED_LIST,
}
const emptyViewState: View = {
  filter: IsActive.FILTER_STATUS_ACTIVE,
  isLoading: false,
  sort: [],
}
export const reducer = Redux.combineReducers({
  data: IsActive.chainedReducer(Sortable.stateReducer(reducerEvent), Constants.UPDATE_BLACKLIST),
  modal: Modal.reducer(modalReducerEvent),
  page: Pager.createReducer(Constants.FETCH_EXCLUDED_LIST),
  search: searchReducer,
  view: IsActive.filterReducer(
    Sortable.viewReducer(reducerEvent), Constants.FETCH_EXCLUDED_LIST, emptyViewState),
})



// WEBPACK FOOTER //
// ./src/pages/blacklists/reducer.ts